import { extend, media, stylesheet } from 'typestyle';
import { ButtonIcon } from '@traceair/tds';
import { BREAKPOINT_LARGE, BREAKPOINT_SMALL } from '../../../layout/styles';
import { CalendarIcon } from '@traceair/webapp-icons';
import React from 'react';
import { useUiStore } from '../../../../store/uiStore';

const css = stylesheet({
  button: extend(
    {
      marginRight: 12,
      display: 'none',
    },
    media({ maxWidth: BREAKPOINT_LARGE }, { display: 'inline-flex' }),
    media({ maxWidth: BREAKPOINT_SMALL }, { marginRight: 0 }),
  ),
});

export const MissionsCalendarButton = () => {
  const { setIsCalendarOpen } = useUiStore();

  const handleClick = () => {
    setIsCalendarOpen(true);
  };

  return <ButtonIcon className={css.button} icon={<CalendarIcon />} size="s" type="white" onClick={handleClick} />;
};
